import { BaseHttpProvider } from "./base";
import { DataProcessingProtocol } from "../processor";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { take } from "rxjs/operators";

export abstract class DeleteProvider<T> extends BaseHttpProvider<T> {
  constructor(public http: HttpClient) {
    super();
  }

  /**
   * @override
   * Disable caching for all delete calls
   */
  get isCachable() {
    return false;
  }

  /**
   * Generate a delete observable and
   */
  protected generateBaseObservable(
    body: string,
    urlSearchParams?
  ): Observable<any> {
    var token =
      this.authProtocol != null && this.authProtocol != undefined
        ? this.authProtocol.getToken()
        : null;
    var deleteReq;
    var userToken;
    let opt = {
      headers: this.getHeaders(userToken),
      body: body,
      params: urlSearchParams,
    };
    // redux support
    if (token instanceof Observable) {
      token.pipe(take(1)).subscribe((user) => {
        if (user) {
          userToken = user.token;
        } else {
          userToken = null;
        }
        opt.headers = this.getHeaders(userToken);
        deleteReq = this.http.delete(this.endpoint, opt);
      });
    }
    // no redux
    else {
      deleteReq = this.http.delete(this.endpoint, opt);
    }
    return deleteReq;
  }
}


export abstract class BaseDeleteProvider<T> extends DeleteProvider<T>
  implements DataProcessingProtocol {
  constructor(public http: HttpClient) {
    super(http);
    this.processingDelegate = this;
  }

  processResponse(response: any) {
    if (!(response instanceof Array)) response = [response];

    var datas = [];
    for (var data of response) {
      var modelObj = new this.model().deserialize(data);
      datas.push(modelObj);
    }

    return datas;
  }
}

export abstract class BaseEavDeleteProvider<T> extends DeleteProvider<T>
  implements DataProcessingProtocol {
  constructor(public http: HttpClient) {
    super(http);
    this.processingDelegate = this;
  }

  processResponse(response: any) {
    let data = new this.model().eavDeserialize(response.attribute);

    return data;
  }
}
